<template>
    <div class="app">
        <router-view></router-view>
    </div>
</template>
<script>
import Axios from 'axios';
export default {
    data() {
        return {};
    }
};
</script>
<style lang="less">
// @import './less/colors.less';
// @import './less/flex.less';
// @import './less/size.less';
html,
body {
    width: 100%;
    height: 100%;
    font-size: 12px;
    background-color: #d7d7d7;
}
img {
    max-width: 100%;
}
li {
    list-style: none;
}
.app {
    width: 100%;
    height: 100%;
}
// .card-title {
//     font-size: 16px;
//     color: @text_color_00;
//     .ivu-icon {
//         color: @blue;
//         font-weight: bold;
//     }
//     .title-icon {
//         height: 24px;
//     }
// }
// 二级导航条
.navbar {
    position: fixed;
    top: 45px;
    left: 95px;
    right: 0;
    z-index: 98;
    height: 45px;
    padding: 0 15px;
    display: flex;
    background-color: #2f3234;
    box-shadow: -5px 0 5px #666;
    a {
        display: flex;
        height: 100%;
        width: 140px;
        flex-shrink: 0;
        padding: 0 15px;
        align-items: center;
        justify-content: center;
        color: #999;
        font-size: 14px;
        font-weight: bold;
        border-right: 1px solid #444;
        &.active {
            background-color: white;
            color: #038390;
        }
        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    h2 {
        width: 100%;
        line-height: 45px;
        text-align: center;
        color: #fff;
        i {
            font-size: 18px;
        }
        small {
            color: #aaa;
            font-size: 70%;
        }
    }
}
// 操作栏
.actions {
    position: fixed;
    top: 90px;
    left: 95px;
    right: 0;
    z-index: 97;
    // height: 75px;
    display: flex;
    align-items: center;
    padding: 15px 10px 15px 15px;
    background-color: #d7d7d7;
    .btns {
        display: flex;
    }
    .box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .actions-func {
            display: flex;
            .ivu-input {
                border: 1px solid #fff;
            }
            .ivu-select-selection {
                border: 1px solid #fff;
            }
        }
    }
}
.bg-green {
    background-color: #009900;
}
.bg-yellow {
    background-color: #c6c013;
}
.bg-red {
    background-color: #ef2917;
}
.bg-grey {
    background-color: #898989;
}
.bg-white {
    background-color: #eeeeee;
}
.tx-green {
    color: #009900;
}
.tx-yellow {
    color: #c6c013;
}
.tx-red {
    color: #ef2917;
}
.tx-grey {
    color: #898989;
}
.tx-white {
    color: #eeeeee;
}
//阴影
.shadow112006 {
    .ivu-select-selection,
    .ivu-select-dropdown,
    input {
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.06);
        border-color: #fff;
    }
}
// 覆盖card样式
.ivu-table th {
    color: #fff;
    background-color: #4b4e51;
}
.ivu-card-head {
    display: flex;
    align-items: center;
    height: 45px;
    padding: 0 15px;
    p {
        color: #515a6e;
    }
}
.ivu-card-extra {
    top: 0;
    right: 0;
    height: 45px;
    .btns {
        display: flex;
        height: 100%;
        align-items: center;
        padding-right: 16px;
    }
    a {
        display: flex;
        height: 100%;
        padding: 0 15px;
        align-items: center;
        color: #515a6e;
        i {
            font-size: 20px;
        }
    }
}
// 清除浮动
.clearfix {
    &:before,
    &:after {
        content: ' ';
        display: table;
    }
    &:after {
        clear: both;
    }
}
// 显示属性设定弹出框
.data-attrs {
    .ivu-checkbox-wrapper {
        display: block;
        float: left;
        width: 20%;
        margin: 10px 0;
    }
}
.padding-r10 {
    padding-right: 10px;
}
.margin-r10 {
    margin-right: 10px;
}
</style>





// WEBPACK FOOTER //
// src/app.vue